<div class="app-dialog dc-share">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2 id="dc-share-title">{{ "digitalCard.owner.shareModalTitle" | translate }}</h2>
      @if (displayName) {
        <p class="app-dialog__subtitle">{{ displayName }}</p>
      }
    </div>
    <button type="button" mat-icon-button (click)="close()" [attr.aria-label]="'digitalCard.owner.closeModal' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    @if (!sourceLinksReady) {
      <div class="dc-share__loading">
        <app-loading [text]="'digitalCard.owner.loading' | translate"></app-loading>
      </div>
    } @else if (shareUrl) {
      <section class="app-dialog__section">
        <header class="app-dialog__section-head dc-share__section-head">
          <h3>{{ "digitalCard.owner.shareQrTitle" | translate }}</h3>
          <p class="dc-share__block-desc">{{ "digitalCard.owner.shareQrDesc" | translate }}</p>
        </header>
        @if (qrSourceUrl) {
          <div class="dc-share__qr" [style.--dc-share-qr-preview.px]="qrPreviewPx">
            <qrcode
              [qrdata]="qrSourceUrl"
              [width]="qrSvgPx"
              [errorCorrectionLevel]="shareQr.errorCorrectionLevel"
              [margin]="shareQr.margin"
              [colorDark]="shareQr.colorDark"
              [colorLight]="shareQr.colorLight"
              [elementType]="'svg'"
              (qrCodeURL)="qrSvgDownloadLink = $event"
            ></qrcode>
          </div>
          <div class="dc-share__qr-export" aria-hidden="true">
            <qrcode
              [qrdata]="qrSourceUrl"
              [width]="qrPngPx"
              [errorCorrectionLevel]="shareQr.errorCorrectionLevel"
              [margin]="shareQr.margin"
              [colorDark]="shareQr.colorDark"
              [colorLight]="shareQr.colorLight"
              [elementType]="'canvas'"
              (qrCodeURL)="qrPngDownloadLink = $event"
            ></qrcode>
          </div>
          <div class="dc-share__qr-actions">
            <button
              type="button"
              mat-stroked-button
              class="dc-share__qr-download"
              [disabled]="!qrSvgDownloadLink"
              (click)="downloadQrSvg()"
            >
              <mat-icon>download</mat-icon>
              {{ "digitalCard.owner.downloadQrSvgButton" | translate }}
            </button>
            <button
              type="button"
              mat-stroked-button
              class="dc-share__qr-download"
              [disabled]="!qrPngDownloadLink"
              (click)="downloadQrPng()"
            >
              <mat-icon>download</mat-icon>
              {{ "digitalCard.owner.downloadQrPngButton" | translate }}
            </button>
          </div>
          <a
            #downloadQrSvgRef
            [href]="qrSvgDownloadLink"
            [download]="qrFileBase + '.svg'"
            class="dc-share__hidden-anchor"
          ></a>
          <a
            #downloadQrPngRef
            [href]="qrPngDownloadLink"
            [download]="qrFileBase + '.png'"
            class="dc-share__hidden-anchor"
          ></a>
        }
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head dc-share__section-head">
          <h3>{{ "digitalCard.owner.shareSocialTitle" | translate }}</h3>
          <p class="dc-share__block-desc">{{ "digitalCard.owner.shareSocialDesc" | translate }}</p>
        </header>
        <div class="dc-share__rows">
          <button type="button" class="dc-share__row" (click)="openShare('whatsapp')">
            <span class="dc-share__row-icon dc-share__row-icon--whatsapp">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            </span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.shareViaWhatsApp" | translate }}</span>
          </button>
          <button type="button" class="dc-share__row" (click)="openShare('facebook')">
            <span class="dc-share__row-icon dc-share__row-icon--facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.shareViaFacebook" | translate }}</span>
          </button>
          <button type="button" class="dc-share__row" (click)="openShare('x')">
            <span class="dc-share__row-icon dc-share__row-icon--x">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.shareViaX" | translate }}</span>
          </button>
          <button type="button" class="dc-share__row" (click)="openShare('linkedin')">
            <span class="dc-share__row-icon dc-share__row-icon--linkedin">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.shareViaLinkedIn" | translate }}</span>
          </button>
          <button type="button" class="dc-share__row" (click)="openShare('email')">
            <span class="dc-share__row-icon dc-share__row-icon--email">
              <mat-icon>mail_outline</mat-icon>
            </span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.shareViaEmail" | translate }}</span>
          </button>
        </div>
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head dc-share__section-head">
          <h3>{{ "digitalCard.owner.shareCopyTitle" | translate }}</h3>
          <p class="dc-share__block-desc">{{ "digitalCard.owner.shareCopyDesc" | translate }}</p>
        </header>
        <div class="dc-share__rows">
          <button type="button" class="dc-share__row" (click)="copyLink()">
            <span class="dc-share__row-icon"><mat-icon>link</mat-icon></span>
            <span class="dc-share__row-label">{{ "digitalCard.owner.copyLink" | translate }}</span>
          </button>
          @if (entryUrl) {
            <button type="button" class="dc-share__row" (click)="copyEntryLink()">
              <span class="dc-share__row-icon"><mat-icon>login</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.shareEntryLink" | translate }}</span>
            </button>
          }
          @if (profileId) {
            <button type="button" class="dc-share__row" (click)="copySourceLink('nfc')">
              <span class="dc-share__row-icon"><mat-icon>nfc</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyNfcLink" | translate }}</span>
            </button>
            <button type="button" class="dc-share__row" (click)="copySourceLink('qr')">
              <span class="dc-share__row-icon"><mat-icon>qr_code_2</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyQrLink" | translate }}</span>
            </button>
            <button type="button" class="dc-share__row" (click)="copySourceLink('nfc_paper')">
              <span class="dc-share__row-icon"><mat-icon>article</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyNfcPaperLink" | translate }}</span>
            </button>
            <button type="button" class="dc-share__row" (click)="copySourceLink('nfc_plastic')">
              <span class="dc-share__row-icon"><mat-icon>credit_card</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyNfcPlasticLink" | translate }}</span>
            </button>
            <button type="button" class="dc-share__row" (click)="copySourceLink('qr_paper')">
              <span class="dc-share__row-icon"><mat-icon>description</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyQrPaperLink" | translate }}</span>
            </button>
            <button type="button" class="dc-share__row" (click)="copySourceLink('qr_plastic')">
              <span class="dc-share__row-icon"><mat-icon>badge</mat-icon></span>
              <span class="dc-share__row-label">{{ "digitalCard.owner.copyQrPlasticLink" | translate }}</span>
            </button>
          }
        </div>
      </section>
    }
  </div>
</div>
